import { render, staticRenderFns } from "./pos-shifts.vue?vue&type=template&id=1055d870&scoped=true&"
import script from "./pos-shifts.vue?vue&type=script&lang=js&"
export * from "./pos-shifts.vue?vue&type=script&lang=js&"
import style0 from "./pos-shifts.vue?vue&type=style&index=0&id=1055d870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1055d870",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
